var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlightIcon = function SvgHighlightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.738 8.03c.636-2.292.957-4.69 1.251-7.018C3.051.51 2.707.045 2.222.009a.88.88 0 0 0-.99.752C.95 3.017.648 5.344.036 7.53a.91.91 0 0 0 .61 1.11.88.88 0 0 0 1.093-.609M10.754 14.977C14.476 11.29 17.718 7.135 21.54 3.52a.89.89 0 0 0 .042-1.253.863.863 0 0 0-1.25-.036C16.498 5.846 13.245 10 9.512 13.688a.93.93 0 0 0-.01 1.29c.342.321.903.357 1.251 0M25.067 21.887l-6.39.322c-.489 0-.865.43-.842.931s.44.86.928.86l6.4-.323a.915.915 0 0 0 .836-.966.885.885 0 0 0-.932-.824"
  }))));
};
export default SvgHighlightIcon;